<template>
  <transition v-if="isOpen">
    <template>
      <div class="modal modal-bg">
        <div class="modal-container max-w--600px">
          <div class="modal-head border-b--1px border--solid border--gray border--lighten-2">
            <strong>비밀번호 확인</strong>
            <form-button
              class="icon--btn btn--xl position--absolute top--0px right--0px font--24px"
              icon="close"
              @click="close"
            ></form-button>
          </div>
          <div class="modal-body">
            <p class="font--14px text--gray pb--24px">이 게시글은 비밀글로 구성되어 있습니다.<br>글을 보시려면 비밀번호를 입력해주시길 바랍니다.</p>
            <form-input
              type="password"
              name="password"
              placeholder="비밀번호를 입력해 주세요"
              v-model="password"
              :error="error"
              @keyup.enter="emitPassword"
            ></form-input>
            <p
              class="text--red"
              v-if="isError"
            >잘못된 비밀번호 입니다. 다시 입력해주세요.</p>
            <!-- 버튼이 필요한 경우 -->
            <div class="pt--20px text--center">
              <button
                class="btn btn--xxxl btn--block black text--white"
                type="button"
                @click="emitPassword"
              >확인</button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </transition>
</template>

<script>
export default {
  props: {
    isOpen: { type: Boolean, default: false },
    isError: { type: Boolean, default: false }
  },
  data () {
    return {
      password: '',
      error: {}
    }
  },
  created () {
    this.password = ''
  },
  watch: {
    isOpen () {
      this.password = ''
    }
  },
  methods: {
    emitPassword () {
      this.$emit('closedDlg', this.password)
    },
    close () {
      this.$emit('closedDlg')
    }
  },
  components: {
    FormButton: () => import('@/component/ui2/button/FormButton'),
    FormInput: () => import('@/component/ui2/form/FormInput')
  }
}
</script>
<!-- 
    <div class="content-modal">
      <div class="content-view">
        <div class="content-body">
          <div class="content__comment">
            <div class="comment__input">
              <div class="comment__form">
                <input
                  class="form-input comment__form-input"
                  placeholder="비밀번호는?"
                  v-model="password"
                  @keyup.enter="emitPassword"
                >
                <p
                  class="text--white"
                  v-if="isError"
                >잘못된 비밀번호 입니다. 다시 입력해주세요.</p>
                <button
                  class="comment__btn-post"
                  @click="emitPassword"
                >
                  보기
                  <span class="post-icon"></span>
                </button>
              </div>
            </div>
            <button
              class="content__btn-close"
              @click="close"
            ></button>
          </div>
        </div>
      </div>
    </div>
 -->
